// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"38":"0bd508ce","76":"631dd869","88":"8d0bde8f"}[chunkId] + ".js";
};